import { FC, MutableRefObject } from 'react'
import { Visible } from '@leroy-merlin-br/backyard-react'

import { scrollToSection } from '../../common/scrollToSection'
import { sections } from '../../common/sections'
import * as S from './styled'
import BackgroundSvg from './components/BackgroundSvg'
import { SectionId } from '../../common/sectionId'

export interface HomeProps {
  refs: MutableRefObject<Record<string, HTMLDivElement | null>>
}

const Home: FC<HomeProps> = ({ refs }) => (
  <S.Container>
    <S.Wrapper>
      <Visible when={['tera']}>
        <S.BackgroundSvg>
          <BackgroundSvg />
        </S.BackgroundSvg>
      </Visible>

      <S.Content>
        <S.Title>Regulamento</S.Title>
        <h1>
          <S.BlackTitle>Leroy Merlin</S.BlackTitle>
          <S.PrimaryTitle>Com Você</S.PrimaryTitle>
        </h1>
        <S.Info>
          O objetivo é aproximar a Leroy e seus clientes com ofertas exclusivas
          descritos neste Regulamento, através do e-mail, SMS, WhatsApp,
          notificação no aplicativo e no computador, por tempo indeterminado.
        </S.Info>
      </S.Content>
    </S.Wrapper>

    <S.NavWrapper>
      <S.NavInfo>Navegue pelos tópicos</S.NavInfo>
      <S.NavItens>
        {sections.slice(1).map(({ id, label }) => (
          <S.Button
            key={id}
            onClick={() => scrollToSection(refs, id as SectionId)}>
            {label}
          </S.Button>
        ))}
      </S.NavItens>
    </S.NavWrapper>
  </S.Container>
)

export default Home
